import * as React from "react"

export default function ReactionGestureOutlineIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.309 3.008c.064.068.152.11.246.116a11.75 11.75 0 011.998.33c.766.2 1.42.478 1.739.815.66.696.48 1.42.345 1.658a.375.375 0 00.145.513l4.412 2.416c.16.088.216.289.126.447l-.672 1.176a.326.326 0 01-.437.126l-3.468-1.88a.375.375 0 00-.474.56l2.63 3.378a.326.326 0 01-.05.45l-.864.72c-.154.128-.434.102-.583-.106-.447-.623-1.041-1.318-1.56-1.93-.535-.631-.968-1.15-1.143-1.458a.375.375 0 00-.53-.128l-.067.056c-.356.374-1.016.59-1.735.584-.72-.006-1.371-.232-1.705-.584-.497-.525-.79-1.21-.948-1.872a5.452 5.452 0 01-.146-1.62.375.375 0 00-.101-.29l-.95-1.004 3.068-3.237.724.764z"
        stroke={props.stroke}
        strokeWidth={1}
        strokeLinejoin="round"
      />
    </svg>
  )
}